/** report.interface */

/** 实验得分-icon类型 */
export interface ScoreIcon {
  label: string;
  value: string;
  iconType: string;
  color: string;
}
/** 实验得分-icon类型-实现类 */
export class ScoreIconImpl implements ScoreIcon {
  /** 提示msg */
  label: string;

  /** 数值 */
  value: string;

  /** icon图标 */
  iconType: string;

  /** 对应颜色 */
  color: string;

  constructor(label: number, value: number) {
    switch (label) {
      case 1:
        this.label = '受灾人数';
        this.iconType = require('@/assets/report/injury.png');
        this.color = '#fbef00';
        this.value = `${value}人`;
        break;
      case 2:
        this.label = '政府公信力';
        this.iconType = require('@/assets/report/process.png');
        this.color = '#1fb1e1';
        this.value = `${value}`;
        break;
      case 3:
        this.label = '群众满意度';
        this.iconType = require('@/assets/report/satisfaction.png');
        this.color = '#6ec421';
        this.value = `${value}%`;
        break;
      case 4:
        this.label = '死亡人数';
        this.iconType = require('@/assets/report/dead.png');
        this.color = '#ff8d2c';
        this.value = `${value}人`;
        break;
      default:
        this.label = '未知类型';
        this.iconType = 'unknown';
        this.color = '#478cd4';
        this.value = `${value}`;
        break;
    }
  }
}
/** 报告-实验得分类型 */
export interface ScoreReport {
  score: number;
  typeList: ScoreIcon[];
}
